<template>
    <div class="row">
        <div class="col-3" v-for="(item,index) in products" :key="index"><router-link :to="'/prodetail/'+item.id">
            <i :class="['bg-style',bgcolors[index],'fa',fas[index],'fa-3x']"></i>
            <p class="con-style">{{item.name}}</p>
        </router-link></div>            
    </div>
</template>
<script>
export default {
    data(){
        return{
            products:[
                {id:1,name:'在线教育云平台'},
                {id:2,name:'企业管理信息系统'},
                {id:3,name:'企事业网站定制'},
                {id:4,name:'公众号、小程序开发'},
                {id:5,name:'企业进销存管理系统'},
                {id:6,name:'建筑劳务企业管理系统'},
                {id:7,name:'广告企业管理系统'},
                {id:8,name:'手机APP开发'},
            ],
            bgcolors:['bgc-1','bgc-2','bgc-3','bgc-4','bgc-5','bgc-6','bgc-7','bgc-8'],
            fas:['fa-recycle','fa-area-chart','fa-id-card','fa-weixin','fa-calendar','fa-male','fa-cogs','fa-mobile']
        }
    }
}
</script>